export function getFilterForBulkAction(selectedRowIds, entityFilter) {
    if (selectedRowIds && selectedRowIds.length > 0) {
        return [{ op: 'in', id: selectedRowIds }];
    }
    return entityFilter;
}
